// extracted by mini-css-extract-plugin
module.exports = {"p7aqsq2":"p7aqsq2","bfjahjy":"bfjahjy","s1e2cci":"s1e2cci"};